import { MacroCycle } from "./macro-cycle";

interface AnnualPlanMacroCycleData {
  id?: number;
  weekFrom?: number;
  weekTo?: number;
  annualPlanId?: number;
  macroCycleId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  macroCycle?: MacroCycle;
}

export class AnnualPlanMacroCycle {
  public static getNonTranslatableFields(): string[] { return ['id', 'weekFrom', 'weekTo', 'annualPlanId', 'macroCycleId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'weekFrom', 'weekTo', 'annualPlanId', 'macroCycleId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  weekFrom?: number;
  weekTo?: number;
  annualPlanId?: number;
  macroCycleId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;


  macroCycle?: MacroCycle;

  public static fromAPI(data: AnnualPlanMacroCycleData, translationsData:any[]): AnnualPlanMacroCycle {
    const macroCycle = data.macroCycle ? MacroCycle.fromAPI(data.macroCycle, translationsData) : undefined;
    return new AnnualPlanMacroCycle({
      id: data.id,
      weekFrom: data.weekFrom,
      weekTo: data.weekTo,
      annualPlanId: data.annualPlanId,
      macroCycleId: data.macroCycleId,
      createDate: data.createDate,
      createrId: data.createrId,
      updateDate: data.updateDate,
      updaterId: data.updaterId,
      deleteDate: data.deleteDate,
      deleterId: data.deleterId,
      macroCycle: macroCycle,
    });
  }

  public static fromAPIList(data: AnnualPlanMacroCycleData[], translationsData:any[]): AnnualPlanMacroCycle[] {
    return data.map((item: AnnualPlanMacroCycleData) => AnnualPlanMacroCycle.fromAPI(item, translationsData));
  }

  constructor({id, weekFrom, weekTo, annualPlanId, macroCycleId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId, macroCycle} : AnnualPlanMacroCycleData) {
    this.id = id;
    this.weekFrom = weekFrom;
    this.weekTo = weekTo;
    this.annualPlanId = annualPlanId;
    this.macroCycleId = macroCycleId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.macroCycle = macroCycle;
  }

  public toJson(): AnnualPlanMacroCycleData {
    return {
      id: this.id,
      weekFrom: this.weekFrom,
      weekTo: this.weekTo,
      annualPlanId: this.annualPlanId,
      macroCycleId: this.macroCycleId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId,
    };
  }
}
